import { render, staticRenderFns } from "./AddEditScaleBased.vue?vue&type=template&id=ef96f57c"
import script from "./AddEditScaleBased.vue?vue&type=script&lang=js"
export * from "./AddEditScaleBased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports